<template>
  <div>
    <div class="container">
      <div class="flex-logo">
        <div class="logo" @click="indexHome">
          <!-- 侧边导航 -->
          <div @mouseleave="hideDetail()" class="move-class">
            <div class="nav-side" ref="navSide">
              <ul>
                <li
                  v-for="item in categoryList"
                  :key="item.area_id"
                  class="sort-list"
                  @mouseenter="showDetail(item)"
                >
                  <div class="flex">
                    <div
                      class="img "
                      :class="defaultCategryIcons[item.show_name]"
                    ></div>
                    <p
                      class="font14"
                      @click.stop="onClassifyClick(null, item.area_id)"
                    >
                      {{ item.show_name }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <transition name="fade">
              <div
                v-show="panelData && panelData.length > 0"
                class="detail-item-panel panel-1"
                :duration="{ enter: 100, leave: 100 }"
                ref="itemPanel1"
              >
                <div class="item-thumb ">
                  <div v-for="panel in panelData" :key="panel.cat_id">
                    <div>
                      <div class="one-classify">{{ panel.name }}</div>
                      <div class="classList">
                        <div
                          class="flex"
                          v-for="panelChild in panel.child"
                          :key="panelChild.cat_id"
                        >
                          <ul>
                            <li class="detail-item-row">
                              <p class="detail-item-title">
                                {{ panelChild.name }}
                              </p>
                              <div class="three-classify">
                                <!--
                                    to="/goodsList"
                                   -->
                                <a
                                  href="#"
                                  v-for="item in panelChild.child"
                                  :key="item.cat_id"
                                >
                                  <span
                                    class="detail-item"
                                    @click.stop="onClassifyClick(item.cat_id)"
                                    >{{ item.name }}</span
                                  >
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!-- 新增Swiper 滚动信息通知-->
          <!-- //vue-awesome-swiper结构-->
          <div class="swiper-com-container-list">
            <div class="qualification-swiper">
              <swiper :options="swiperOption"  ref="mySwiper" >
                <swiper-slide class="swiper-slide" v-for="(item,index) in qualificationList.qualifies" :key="index">
                  <p>{{ item.name }}: &nbsp;</p>
                  <div v-html="filterChar(item.content) || ''"></div>
                </swiper-slide>
                <!-- 分页器 -->
                <!--<div class="swiper-pagination" slot="pagination"></div>-->
              </swiper>
            </div>
          </div>
          <!-- 新增Swiper 滚动信息通知-->

        </div>

        <div class="title">
          <ul class="title-nav">
            <li
              v-for="(items, index) in nav"
              :key="index"
              :class="{ active: curPath === items.path }"
            >
              <a href="#" @click="toSecPath(items)">{{ items.name }}</a>
              <!-- <router-link :to="items.path">{{ items.name }}</router-link> -->
            </li>
          </ul>
        </div>
        <div class="search-main">
          <Input
            class="search-input"
            search
            placeholder="输入商品/厂家汉字或拼音首字母"
            v-model="searchData"
            @on-search="searchKeyWord"
            @on-change="changeKeyWord"
            @on-blur="listNone"
          />
          <div class="hotSearch">
            热门搜索：
            <span
              v-for="(ites, index) in hotWordsList.search_new"
              :key="index"
              @click="goHotWords(ites.name)"
              >{{ ites.name }}</span
            >
          </div>
          <div class="searchList" v-show="searchContent">
            <div class="search-goodList">
              <ul>
                <li class="title">
                  <span></span>
                  产品
                </li>
                <li
                  class="item"
                  v-for="(item, index) in searchList.goods"
                  :key="index"
                >
                  <p @click="toList(item)"><span></span> {{ item }}</p>
                  <span class="firstManufacturer"></span>
                </li>
              </ul>
            </div>
            <div class="manufactor-goodList">
              <ul>
                <li class="title">
                  <span></span>
                  厂家
                </li>
                <li
                  class="item"
                  v-for="(item, index) in searchList.manufacturer"
                  :key="index"
                >
                  <p @click="toList(item)"><span></span> {{ item }}</p>
                  <span class="firstManufacturer"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!--<i-input v-model="sreachData" size="large" class="sreach" placeholder="输入你想查找的商品">
          <Button slot="append" icon="ios-search" @click="sreach"></Button>
        </i-input>-->
        <!--<Tag v-for="(item, index) in promotionTags" :key="index" closable  @on-close="closeTags(index)"><span @click="selectTags(index)">{{item}}</span></Tag>-->
      </div>
    </div>

    <!--吸顶-->
    <div class="flex-container" id="flex-container">
      <div class="isFixed">
        <div class="container">
          <div class="flex-logo">
            <div class="logo" @click="indexHome"></div>
            <div class="title">
              <ul class="title-nav">
                <li v-for="(item, index) in nav" :key="index">
                  <router-link :to="item.path">{{ item.name }}</router-link>
                </li>
              </ul>
            </div>
            <div class="search-main">
              <Input
                class="search-input"
                search
                placeholder="输入商品/厂家汉字或拼音首字母"
                v-model="searchData"
                @on-search="searchKeyWord"
                @on-change="changeKeyWord"
                @on-blur="listNone"
              />
              <div class="searchList" v-show="searchContent">
                <div class="search-goodList">
                  <ul>
                    <li class="title">
                      <span></span>
                      产品
                    </li>
                    <li
                      class="item"
                      v-for="(item, index) in searchList.goods"
                      :key="index"
                    >
                      <p @click="toList(item)"><span></span> {{ item }}</p>
                      <span class="firstManufacturer"></span>
                    </li>
                  </ul>
                </div>
                <div class="manufactor-goodList">
                  <ul>
                    <li class="title">
                      <span></span>
                      厂家
                    </li>
                    <li
                      class="item"
                      v-for="(item, index) in searchList.manufacturer"
                      :key="index"
                    >
                      <p @click="toList(item)"><span></span> {{ item }}</p>
                      <span class="firstManufacturer"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--<i-input v-model="sreachData" size="large" class="sreach" placeholder="输入你想查找的商品">
              <Button slot="append" icon="ios-search" @click="sreach"></Button>
            </i-input>-->
            <!--<Tag v-for="(item, index) in promotionTags" :key="index" closable  @on-close="closeTags(index)"><span @click="selectTags(index)">{{item}}</span></Tag>-->
          </div>
        </div>
      </div>
    </div>
    <!--吸顶-->
  </div>
</template>

<script>
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from "vue-awesome-swiper"; //局部引入
/*import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";*/
import $ from "jquery";
import store from "@/vuex/store";
import { mapState, mapGetters } from "vuex";
import { getNavBar } from "@/api/commonApi";
import { defaultCategryIcons } from "./nav/categoryIcons";
import { getCategory, getGoodsSearch} from "@/api/goods";
import { getIndexQualifiesInfo} from "@/api/index";
import { getRightNumAndHotWords } from "@/api/commonApi";
import { isEmpty } from "@/utils";
import { homeNavBarRoute } from "./nav/staticData";
import nav from "@/mixins/nav";

export default {
  name: "Search",
  mixins: [nav],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: "vertical",
        pagination: {
          el: ".swiper-pagination", //分页器作用对象
          clickable: true //分页器小圆点是否可点击
        },
        autoplay : 2000,//可选选项，自动滑动
        loop : true,//可选选项，开启循环
      },
      nav: [
        { type: "首页", path: "" },
        { type: "普药", path: "/GoodsList" },
        { type: "中药专区", path: "/ChineseMedicineZone" },
        {
          type: "医药器械",
          path: ""
        },
        {
          type: "品牌专区",
          path: ""
        },
        {
          type: "促销专区",
          path: "/Promotion"
        },
        {
          type: "高毛专区",
          path: ""
        },
        {
          type: "积分商城",
          path: "/PointsMall"
        }
      ],

      promotionTags: [
        "买2免1",
        "领200神券",
        "199减100",
        "母婴5折抢",
        "充100送20"
      ],
      panel1: false,
      panel2: false,
      panelData1: {
        classNav: [
          {
            classify: "五官科类用药",
            title: "西药",
            tags: []
          }
        ]
      },
      panelData2: {
        classNav: [
          {
            classify: "皮肤及外用药",
            title: "西药",
            tags: []
          }
        ]
      },
      panelData: [],
      curArea_id: "", //当前选中的大分类
      categoryList: [],
      defaultCategryIcons: defaultCategryIcons,
      homeNavBarRoute,
      searchData: "", //搜索框搜索数据
      searchContent: false, //搜索下拉框默认隐藏
      searchList: [], //搜索下拉列表
      hotWordsList: [], //搜索热词列表
      qualificationList: [] //资质滚动列表
    };
  },
  computed: {
    ...mapState(["marketing"]),
    ...mapGetters(["navData"]),
    curPath() {
      let pathList = this.$route.path.split("/");
      console.log("curPath", pathList);
      if (pathList.length > 1) {
        return `/${pathList[1]}`;
      } else {
        return "/";
      }
    }
  },
  watch: {
    navData: {
      handler(newVal, oldVal) {
        this.nav = this.navData;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    $(function() {
      //1.内容大于800px scroll--->scrollTop
      $(window).on("scroll", function() {
        var $scroll = $(this).scrollTop();
        if ($scroll >= 700) {
          $("#flex-container").show();
        } else {
          $("#flex-container").hide();
        }
      });
    });
    // this.getNavData();
    this.getGoodsCategory();
    this.hotList();
    this.qualificationsList();
    /* this.$refs.itemPanel1.style.left =
       this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
     this.$refs.itemPanel2.style.left =
       this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
     this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + 'px';
     this.$refs.itemPanel2.style.top = this.$refs.navSide.offsetTop + 'px';*/

  },
  methods: {
    filterChar(html) {
      return html ?
              html.replace(html ? /&(?!#?\w+;)/g : /&/g, "&amp;")
                      .replace(/&lt;/g, "<")
                      .replace(/&gt;/g, ">")
                      .replace(/&amp;nbsp;/g, "&nbsp;")
                      .replace(/&quot;/g, '"')
                      .replace(/&#39;/g, "'") : '';
    },
    classStyle() {
      /*鼠标移入右侧分类样式改变*/
      $(".nav-side").css({ borderRadius: "10px 0 0 10px" });
    },
    moveClassStyle() {
      /*鼠标移出右侧分类样式恢复*/
      $(".nav-side").css({ borderRadius: "10px" });
    },
    indexHome() {
      this.$router.push("/");
    },
    closeTags(index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags(index) {
      /* this.sreachData = this.promotionTags[index];*/
    },
    qualificationsList() {
      /**首页资质信息滚动获取 */
      let _this = this;
      getIndexQualifiesInfo()
              .then(res => {
                console.log("获取首页资质11111111", res);
                this.qualificationList = res.data;
              })
              .catch(err => {
                console.log(err);
              });
    },

    searchKeyWord() {
      /**点击获取搜索列表 */
      console.log("searchKeyWord");
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: this.searchData,
            show_id: '' //普药
          }
        }
      });
    },
    /*关键字change更改*/
    changeKeyWord() {
      console.log("changeKeyWord");

      /**搜索框change获取搜索列表 */
      let _this = this;
      if (_this.searchData.trim().length > 0)
        getGoodsSearch({ keywords: _this.searchData })
          .then(res => {
            console.log("获取搜索关键字", _this.searchData);
            console.log("获取搜索列表", res);
            this.searchList = res.data;
            if (
              this.searchList.goods.length != 0 ||
              this.searchList.manufacturer.length != 0
            ) {
              this.searchContent = true;
            }
          })
          .catch(err => {
            console.log(err);
          });
      else {
        this.searchContent = false;
      }
    },
    /**搜索按钮点击 */
    searchClick() {
      console.log("搜索按钮点击");
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: this.searchData,
            show_id: '' //普药
          }
        }
      });
    },
    toList(item) {
      /*带关键字跳转列表*/
      console.log(1, item);
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: item,
            show_id: '' //普药
          }
        }
      });
    },
    goHotWords(name) {
      /*带热门搜索词跳转列表*/
      console.log(2, name);
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            keywords: name,
            show_id: '' //普药
          }
        }
      });
    },
    hotList() {
      /**搜索框下方-热门搜索 */
      let _this = this;
      getRightNumAndHotWords()
        .then(res => {
          console.log("获取搜索热词", res);
          this.hotWordsList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    listNone() {
      setTimeout(() => {
        /*搜索框失去焦点时-下拉搜索列表隐藏*/
        this.searchContent = false;
      }, 500);
    },
    showDetail(row) {
      if (!isEmpty(row)) {
        this.curArea_id = row.area_id;
        this.panelData = row.categories;
      }
    },
    hideDetail(level) {
      this.panelData = [];
    },
    /*监听滚动*/
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#searchBar").offsetTop;
      scrollTop > offsetTop
        ? (this.searchBarFixed = true)
        : (this.searchBarFixed = false);
      console.log(scrollTop);
    },
    getNavData() {
      getNavBar()
        .then(res => {
          console.log("获取导航栏", res);
          if (res.data) {
            res.data.forEach(element => {
              let nav = this.homeNavBarRoute.find(nav => {
                return nav.id === element.id + "";
              });
              element.path = nav ? nav.path : "";
            });
            this.nav = res.data;
            let homeItem = { id: "0", name: "首页", url: "/", path: "/" };
            this.nav.unshift(homeItem);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getGoodsCategory() {
      getCategory()
        .then(res => {
          this.categoryList = [];
          this.categoryList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onClassifyClick(cat_id, area_id) {
      this.$store.dispatch("goods/setGoodListFrom", 1);
      console.log("分类点击", cat_id, area_id);
      this.$router.push({
        path: "/GoodsList",
        query: {
          t: new Date().getTime(),
          ...{
            area_id: area_id || this.curArea_id,
            cat_id: cat_id || "",
            show_id: 13 //普药
          }
        }
      });
    }
  },
  updated() {
    /* this.$refs.itemPanel1.style.left =
       this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
     this.$refs.itemPanel2.style.left =
       this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
     this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + 'px';
     this.$refs.itemPanel2.style.top = this.$refs.navSide.offsetTop + 'px';*/
  },
  destroyed() {
    /*销毁滚动监听*/
    window.removeEventListener("scroll", this.handleScroll);
  },
  store
};
</script>

<style lang="less" scoped>
#flex-container {
  width: 100%;
  display: none;
}
.isFixed {
  position: fixed;
  background-color: #fff;
  top: 0;
  z-index: 999;
  width: 100%;
  box-shadow: 0 5px 4px 0 rgb(0 0 0 / 5%);
}
.container {
  width: 1200px;
  margin: 0 auto;
}
/*--------------搜索------------------*/
.search-main {
  position: relative;
  .search-input {
    width: 230px;
    height: 30px;
    background: #f1f1f1;
    border-radius: 15px;
    margin-top: 30px;
    position: relative;
  }
  .search-input /deep/ .ivu-input:focus {
    border-color: #dcdee2;
    outline: 0;
    box-shadow: 0 0 0 0 rgb(255 255 255 / 0%);
  }
  .search-input /deep/ .ivu-input:hover {
    border-color: #dcdee2;
  }
  input {
    outline: 0;
  }
  .hotSearch {
    margin-top: 6px;
    font-size: 14px;
    span {
      color: #358DD1;
      margin-right: 5px;
      cursor: pointer;
    }
  }
  .searchList {
    position: absolute;
    top: 60px;
    left: 0;
    z-index: 15;
    width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #fff;
    font-size: 12px;
    color: #666;
    text-indent: 10px;
    border: 1px solid #eaeaea;
    padding: 5px 0;
    .search-goodList {
    }
    .title {
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      font-weight: 700;
      color: #358DD1;
      span {
        display: inline-block;
        width: 3px;
        height: 14px;
        background-color: #358DD1;
        margin-right: 4px;
      }
    }
    .item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      p {
        /* width: 140px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        height: 24px;
        line-height: 24px;
        span {
          color: #fa0000;
        }
      }
      .firstManufacturer {
        margin-top: 10px;
        /*width: 60px;*/
        height: 16px;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
        color: #666;
        font-size: 14px;
      }
    }
    .item:hover {
      background-color: #f6f6f6;
    }
  }
}
/*--------------搜索------------------*/
.flex-logo {
  width: 100%;
  height: 90px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  .logo {
    width: 190px;
    height: 63px;
    background: url(./../../static/img/index/logo.png) no-repeat;
    cursor: pointer;
    margin-top: 12px;
    position: relative;
  }
  .swiper-com-container-list{
    margin-top: 58px;
    /* flex: 1;*/
    /* .swiper-com-container{*/
    /* 公告滚动 */
    .qualification-swiper {
      width: 390px;
      position: relative;
      height: auto;
     /* padding: 10px 10px 10px 20px;*/
      padding-left: 10px;
      margin: 0;
    }
    .qualification-swiper .swiper-container {
      width: 100%;
      height: 20px;
      min-height: 20px;
    }
  /*  .qualification-swiper .swiper-wrapper{
      width: 290px;
      height: 20px;
    }*/
    .qualification-swiper .swiper-slide {
      width: 390px;
      height: 20px;
      min-height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .qualification-swiper .swiper-slide p {
      color: #333;
      /*overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;*/
    }
    .qualification-swiper .swiper-slide div {
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .qualification-swiper .swiper-pagination {
      position: absolute;
    }
    .qualification-swiper
    .swiper-container-vertical
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
      margin: 3px 0;
      display: block;
    }

    .qualification-swiper .swiper-container {
      width: 100%;
      /* height: 100%;*/
    }
    .qualification-swiper .swiper-slide {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      /* background: #fff;*/
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      /*        -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;*/
    }
    /*  }*/
  }
}
.title {
  line-height: 55px;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  // padding: 0 10px;

  .title-nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-around;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding-left: 0px;
    padding-bottom: 10px;
    margin-bottom: -10px;
    li {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #252525;
      /*  line-height: 22px;*/
      margin: 20px 0 10px 0;
      cursor: pointer;
      a {
        color: #252525;
      }
    }
    .active {
      a {
        background: #358DD1;
        border-radius: 13px;
        color: #fff;
        padding: 3px 14px;
      }
    }
  }

  // .title-nav li:first-child a {
  //   background: #358DD1;
  //   border-radius: 13px;
  //   color: #fff;
  //   padding: 3px 14px;
  // }
}

.move-class:hover .nav-side {
  border-radius: 10px 0 0 10px;
}
.nav-side {
  width: 220px;
  height: 410px;
  padding: 0;
  color: #333;
  z-index: 10;
  position: absolute;
  top: 100px;
  left: 0;
  background: #fcfcfe;
  box-shadow: 0px 2px 8px 0px rgba(179, 179, 179, 0.2);
  border-radius: 10px;
}
.nav-side:hover {
}

.sort-list {
  .flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .img {
    width: 22px;
    height: 22px;
    margin: 0 8px 0 12px;
  }
  .img0 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -14px -16px;
  }
  .img1 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -48px -16px;
  }
  .img2 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -82px -16px;
  }
  .img3 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -116px -16px;
  }
  .img4 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -150px -16px;
  }
  .img5 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -184px -16px;
  }
  .img6 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -218px -16px;
  }
  .img7 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -252px -16px;
  }
  .img8 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -286px -16px;
  }
  .img9 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -320px -16px;
  }
  .img10 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -14px -51px;
  }
  .img11 {
    background: url(./../../static/img/index/indexIcon.png) no-repeat -48px -51px;
  }
}
.sort-list:first-child {
  border-radius: 10px 0 0 0;
}
.sort-list:last-child {
  border-radius: 0 0 0 10px;
}
.nav-side ul {
  width: 100%;
  padding: 0;
  list-style: none;
}
.nav-side li {
  height: 34px;
  line-height: 34px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  cursor: pointer;
  font-size: 12px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
}
.nav-side li:hover {
  background: #fff;
}
.nav-side-item:hover {
  cursor: pointer;
  color: #c81623;
}
.nav-side .sort-list:hover .detail-item-panel {
  display: block;
}
/*导航内容*/
.nav-content {
  width: 100%;
  /* margin-left: 15px;*/
  /*overflow: hidden;
  float: left;*/
}
.nav-content /deep/ .ivu-carousel-arrow.right {
  right: 360px;
}
.nav-content /deep/ .ivu-carousel-arrow.left {
  left: 620px;
}
.nav-content /deep/ .ivu-carousel-arrow {
  width: 60px;
  height: 60px;
  font-size: 2em;
}
.nav-content /deep/ .ivu-carousel-dots-inside {
  display: block;
  position: absolute;
  bottom: 140px;
  left: -17%;
}
.nav-content /deep/ .ivu-carousel-dots li button {
  background-color: #358DD1;
}
.nav-content /deep/ .ivu-icon {
  line-height: 2;
}
/*导航图片*/
.nav-show-img {
  margin-top: 10px;
  float: left;
}
.nav-show-img:nth-child(2) {
  margin-left: 12px;
}
/*显示商品*/
.content {
  width: 100%;
}
/*显示商品详细信息*/

.detail-item-panel {
  width: 750px;
  height: 410px;
  background-color: #fff;
  position: absolute;
  top: 100px;
  left: 220px;
  z-index: 999;
  padding-right: 20px;
  border-radius: 0 10px 10px 0;
}
.item-thumb {
  width: 740px;
  height: 410px;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 15px;
}
/* 设置滚动条的样式 */
.item-thumb::-webkit-scrollbar {
  width: 5px;
}
/* 滚动槽 */
.item-thumb::-webkit-scrollbar-track {
  /* -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);*/
  border-radius: 10px;
  background-color: #f8f8f8;
}
/* 滚动条滑块 */
.item-thumb::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #dff8ff;
  height: 10px;
  max-height: 20px !important;
  min-height: 11px !important;
  /*  background: -ms-radial-gradient(ellipse, #95D1E8, #f8f8f8);
  background: -webkit-radial-gradient(ellipse, #95D1E8, #f8f8f8);
  background: -moz-radial-gradient(ellipse, #95D1E8, #f8f8f8);
  background: radial-gradient(ellipse, #95D1E8, #f8f8f8);*/
}
.detail-item-panel::-webkit-scrollbar-thumb:window-inactive {
  height: 10px;
  max-height: 20px !important;
}
.nav-detail-item {
  margin-left: 26px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  color: #eee;
}
.nav-detail-item span {
  padding: 6px;
  padding-left: 12px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6e6568;
}
.nav-detail-item span:hover {
  margin-left: 15px;
  background-color: #f44336;
}
.detail-item-panel ul {
  list-style: none;
}
.detail-item-panel li {
  line-height: 25px;
  margin-left: 30px;
}
.detail-item-title {
  border-left: 2px solid #358DD1;
  text-indent: 9px;
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
}
.detail-item-title:hover {
  color: #358DD1;
}
.detail-item-row a {
  color: #555555;
}
.detail-item-row .detail-item:first-child {
}
.detail-item-row a .detail-item {
  padding: 0 14px;
  cursor: pointer;
  font-size: 12px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.detail-item-row a .detail-item {
  border-left: 1px solid #efefef;
  text-align: center;
  &:hover {
    color: #358DD1 !important;
  }
}
.detail-item-row a:first-child .detail-item:first-child {
  display: inline-block;
  padding: 0 14px 0 0;
  border: none;
}
.three-classify {
  box-sizing: border-box;
  padding-top: 10px;
  border-top: 1px solid #efefef;
  margin-top: 10px;
}
.detail-item:hover {
  color: #358DD1;
}
.classList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  .flex {
    width: 50%;
  }
}
.one-classify {
  font-size: 16px;
  font-family: PingFangHK-Medium, PingFangHK;
  font-weight: 500;
  color: #358DD1;
  line-height: 22px;
  padding: 26px 0 0 29px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue